import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopShopify = dynamic(() => import("../../components/software-partners/Shopify/DesktopShopify"), {
    loading: () => <Loading />,
});

const MobileShopify = dynamic(() => import("../../components/software-partners/Shopify/MobileShopify"), {
    loading: () => <Loading />,
});

const shopify = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>QueueBuster POS with Shopify Integration | Unify Your Online & Offline Sales</title>
                <meta name="description" content="Integrate QueueBuster POS with Shopify to sync your online and in-store operations seamlessly. Manage inventory, orders, and customers effortlessly with this powerful integration." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/shopify" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/shopify" hrefLang="en-us" />
                <meta property="og:title" content="QueueBuster POS + Shopify Integration: Simplified E-Commerce Managemen" />
                <meta property="og:description" content="Boost your retail business with QueueBuster POS and Shopify integration. Manage both online and offline sales, inventory, and orders with ease and efficiency." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/adsr.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/shopify" />
            </Head>
            {mobileView ? <MobileShopify /> : <DesktopShopify />}
        </>
    )
}

export default shopify